import {TriangleDownIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import type {ComponentPropsWithRef} from 'react'

import styles from './ListFilterButton.module.css'

type PrimerButtonProps = ComponentPropsWithRef<typeof Button>
type OverlayTriggerProps = Required<Pick<PrimerButtonProps, 'aria-expanded' | 'aria-haspopup'>>

export type ListFilterButtonProps = Omit<
  PrimerButtonProps,
  'aria-expanded' | 'aria-haspopup' | 'as' | 'className' | 'variant' | 'trailingAction' | 'trailingVisual'
> &
  OverlayTriggerProps

export function ListFilterButton({ref, ...props}: ListFilterButtonProps) {
  return (
    <Button
      {...props}
      ref={ref}
      className={styles.ListFilterButton}
      variant="invisible"
      trailingAction={TriangleDownIcon}
    />
  )
}

ListFilterButton.displayName = 'ListFilterButton'
